module.exports = __webpack_public_path__ + "img/bell-icon-light.99e85a9d.svg";